import React from "react";
import Swal from "sweetalert2";
import { MakeAxiosRequest } from "../utils/handler";
import withReactContent from "sweetalert2-react-content";
import successImage from "../Assets/Images/success.png";
import deniedImage from "../Assets/Images/denied.png";

export const SwalConfirm = async (props) => {
  const preloadImage = (src) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(src);
      img.onerror = () => reject(new Error("Failed to load image"));
      img.src = src;
    });

  try {
    // Display confirmation dialog
    const result = await Swal.fire({
      title: props.title || "Confirm your Action",
      html: props.subText,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      customClass: { confirmButton: "btn btn-primary" },
      cancelButtonText: "No",
      reverseButtons: true,
    });

    // If user confirms
    if (result.isConfirmed) {
      if (props.actionUrl) {
        const res = await MakeAxiosRequest("post", props.actionUrl, props.actionParams);

        if (res.status === 1) {
          props.successFn?.();
          const successImageUrl = await preloadImage(successImage); // Preload success image
          showCustomAlert({
            html: `<img src="${successImageUrl}" alt="Success Icon">
                   <h3 class="mt-4 mb-0 white">${props.successMsg || res.message}</h3>`,
            type: "",
            timer: 3000,
            showButton: false,
          });
        } else if (res.status === -1) {
          showCustomAlert({
            html: `<p class="mb-0 white">${res.message}</p>`,
            type: "warning",
            title: "Warning",
          });
        } else {
          showCustomAlert({
            html: `<p class="mb-0 white">${res.message}</p>`,
            type: "error",
            title: "Error",
          });
        }
      } else {
        props.successFn?.();
      }
    }
  } catch (error) {
    showCustomAlert({
      html: `<p class="mb-0 white">${props.errorMsg || "An error occurred."}</p>`,
      type: "error",
      title: "Error",
    });
  }
};

// Helper function to show SweetAlert
const showCustomAlert = ({ html, type, title, timer = null, showButton = true }) => {
  Swal.fire({
    html,
    icon: type,
    title,
    customClass: {
      popup: "custom-popup",
      title: "custom-title",
      content: "custom-content",
      confirmButton: "btn btn-primary",
    },
    confirmButtonColor: "#7166D6",
    showConfirmButton: showButton,
    timer,
  });
};


export const SwalError = async (props) => {
  const MySwal = withReactContent(Swal);

  const customSuccessIcon = `
  <p className="mb-0 white">${props.msg}</p>
`;

  MySwal.fire({
    html: customSuccessIcon, // Use custom HTML for the icon
    icon: "error",
    title: "Error",
    customClass: {
      popup: "custom-popup",
      title: "custom-title",
      content: "custom-content",
      confirmButton: "btn btn-primary",
    },
    confirmButtonColor: "#7166D6",
    showConfirmButton: true, // Hide the OK button
    // timer: 3000, // Auto-close after 3000 milliseconds (3 seconds)
  });

  // MySwal.fire({
  //   icon: 'error', title: 'Error', customClass: { confirmButton: 'btn btn-primary' }, text: props.msg,
  // });
};

export const SwalSuccess = async (props) => {
  const MySwal = withReactContent(Swal);
  // Function to preload the image
  const preloadImage = (src) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(src);
      img.src = src;
    });
  };

  try {
    // Preload the success image
     const successIcon = props?.icon ? props.icon :successImage;
     console.log(successIcon,'icon');
    await preloadImage(successIcon);

    const customSuccessIcon = `
      <img src="${successIcon}" alt="Success Icon">
      <h6 class=" mb-0 mx-4">${props.msg}</h6>
      ${props.subText ? `<p class="mt-3 mb-0 white">${props.subText}</p>` : ''}
    `;

    // Display the SweetAlert after the image has been preloaded
    MySwal.fire({
      html: customSuccessIcon, // Use custom HTML for the icon
      customClass: {
        popup: "custom-popup",
        title: "custom-title",
        content: "custom-content",
        confirmButton: "custom-confirm-button",
      },
      confirmButtonColor: "#7166D6",
      showConfirmButton: props.showbtn, // Hide the OK button
      confirmButtonText: props.btnText || 'OK', // Set the text for the confirm button
      timer: props.showbtn ? null : 3000, // Auto-close after 3000 milliseconds if button is not shown
    }).then((result) => {
      console.log(result);
      if (result.isConfirmed) {
        props.successFn();
      }
    });
  } catch (error) {
    console.error("Image loading failed", error);
  }
};


export const SwalWarning = async (props) => {
  const MySwal = withReactContent(Swal);

  const customSuccessIcon = `
     <div>
      <i class="swal2-icon swal2-warning swal2-icon-show" style="display: flex;"></i>
      <p class="mt-4 mb-0 white">${props.msg}</p>
    </div>
  `;

  MySwal.fire({
    title: 'Warning',
    html: customSuccessIcon, 
    customClass: {
      popup: "custom-popup",
      title: "custom-title",
      content: "custom-content",
      confirmButton: "btn btn-primary",
      cancelButton: "btn btn-secondary",
    },
    confirmButtonColor: "#7166D6",
    showConfirmButton: true, 
    showCancelButton: true, // Show Cancel Button
    cancelButtonText: "Cancel",
    confirmButtonText: "OK",
  }).then((result) => {
    // Only navigate if the confirm button is clicked
    if (result.isConfirmed && props.onClose) {
      props.onClose();
    }
  });
};

export const deleteAccountSwal = async (props) => {
  const MySwal = withReactContent(Swal);

  try {
    const customIcon = `
    <img src="${deniedImage}" alt="Success Icon">
    <h3 class="mt-4 mb-0 white">${props.title}</h3>
    ${props.description ? `<p class="mt-3 mb-0 white">${props.description}</p>` : ''}
  `;

    const result = await MySwal.fire({
      // title: props.title || "Confirm your Action",
      html: customIcon, // Use custom HTML for the icon

      // html: props.subText,
      // icon: "warning",
      showCancelButton: false,
      showConfirmButton: props.show_pause_membership, // Hide the OK button
      showDenyButton: props.show_delete_account,  // This will show a second action button
      confirmButtonText: props.pauseMembershipLabel, // Text for the first action button
      denyButtonText: props.deleteButtonLabel,    // Text for the second action button
      cancelButtonText: "Cancel",
      reverseButtons: true,
      customClass: {
        popup: "custom-popup",
        title: "custom-title",
        content: "custom-content",
        confirmButton: "custom-confirm-button",
      },
      confirmButtonColor: "#7166D6",
    });

    if (result.isConfirmed) {
      // First action
      props.membershipAction && props.membershipAction(props.membership_alert_message);
    } else if (result.isDenied) {
      // Second action
      props.deleteAccountAction && props.deleteAccountAction();
    }
  } catch (error) {
    const customSuccessIcon = `<p className="mb-0 white">${props.errorMsg || "An error occurred."}</p>`;

    MySwal.fire({
      html: customSuccessIcon, // Use custom HTML for the icon
      icon: "error",
      title: "Error",
      customClass: {
        popup: "custom-popup",
        title: "custom-title",
        content: "custom-content",
        confirmButton: "custom-confirm-button",
      },
      confirmButtonColor: "#7166D6",
      showConfirmButton: true, // Hide the OK button
      // timer: 3000, // Auto-close after 3000 milliseconds (3 seconds)
    });
  }
};